module.exports = __webpack_public_path__ + "static/media/yxks.110cb28.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/yxks.mp3
// module id = H8AX
// module chunks = 1